import { Risk, Size } from './';

export interface IndicatorProps {
  className?: string;
  innerRadius?: number;
  outerRadius?: number;
  radius?: number;
  risk: Risk;
  score: number;
  size?: Size;
  strokeWidth?: number;
}
